import React from 'react'
import { t } from 'ttag'

import { SendTestsMessageModal } from 'components/modals/common/SendTestsMessageModal/SendTestsMessageModal'

export const SendTestsInvitationsModal = ({
  candidates,
  deadline,
  name,
  onCancel,
  onClose,
  onConfirm,
  isOpen,
}) => (
  <SendTestsMessageModal
    title={t`Send invitation message`}
    subtitle={t`Invitation messages`}
    type="invitation"
    {...{ candidates, name, deadline, onCancel, onClose, onConfirm, isOpen }}
  />
)
